import { Component, inject } from '@angular/core';
import { SeoService } from '../core/seo.service';
import { BlogListWidgetComponent } from '../widgets/blog/blog-list-widget.component';
import { I18nService } from '../core/i18n.service';
import { SiteConfigService } from '../core/site-config.service';

@Component({
  selector: 'app-blog-page',
  imports: [BlogListWidgetComponent],
  template: `<app-blog-list-widget />`
})
export class BlogPage {
  private readonly seo = inject(SeoService);
  private readonly i18n = inject(I18nService);
  private readonly site = inject(SiteConfigService);

  constructor() {
    this.seo.setPage({
      title: 'Blog',
      description: this.site.config().brandKey === 'bdsmbeds'
        ? 'BDSMBeds product guides, furniture care, delivery information and practical buying advice.'
        : this.i18n.t('blogSeoDescription'),
      path: this.i18n.routePath('blog')
    });
  }
}
